export default __webpack_public_path__ + "static/media/tem_no_parque2.2e30a902.jpg";